import { render, staticRenderFns } from "./TodayOrderSettingsModal.vue?vue&type=template&id=192611c8&scoped=true"
import script from "./TodayOrderSettingsModal.vue?vue&type=script&lang=js"
export * from "./TodayOrderSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TodayOrderSettingsModal.vue?vue&type=style&index=0&id=192611c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192611c8",
  null
  
)

export default component.exports